import { CsrfHeaderName } from '@lg/shared'
import {
	Subject,
	filter,
	from,
	map,
	shareReplay,
	startWith,
	switchMap,
	tap,
} from 'rxjs'
import { toSignal } from '@angular/core/rxjs-interop'

export class CsrfService {
	private refreshCsrfTokenSubject = new Subject<void>()

	readonly csrfToken$ = this.refreshCsrfTokenSubject.pipe(
		startWith(undefined),
		switchMap(() =>
			from(fetch('/__csrfToken')).pipe(
				map((response) => response.headers.get(CsrfHeaderName) ?? ''),
			),
		),
		tap(console.log),
		shareReplay(1),
	)
	readonly csrfToken = toSignal(this.csrfToken$)
	readonly isLoaded$ = this.csrfToken$.pipe(
		filter((token) => !!token),
		map(() => {
			// console.log('CSRF token is loaded')
			return undefined
		}),
		shareReplay(1),
	)

	refreshCsrfToken() {
		this.refreshCsrfTokenSubject.next()
	}
}
